import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface FileInfo {
  url: string;
  filename: string;
  selected: boolean;
}

export interface FileSelectionDialogData {
  files: FileInfo[];
}

@Component({
    selector: 'app-file-selection-dialog',
    templateUrl: './file-selection-dialog.component.html',
    styleUrls: ['./file-selection-dialog.component.scss'],
    standalone: false
})
export class FileSelectionDialogComponent {
  files: FileInfo[];

  constructor(
    public dialogRef: MatDialogRef<FileSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FileSelectionDialogData
  ) {
    this.files = data.files;
  }

  get selectedCount(): number {
    return this.files.filter(f => f.selected).length;
  }

  get allSelected(): boolean {
    return this.files.length > 0 && this.files.every(f => f.selected);
  }

  toggleSelectAll(): void {
    const newState = !this.allSelected;
    this.files.forEach(f => f.selected = newState);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onDownload(): void {
    const selectedFiles = this.files.filter(f => f.selected);
    this.dialogRef.close(selectedFiles);
  }
}
